import { Flame } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { useForceLiquidateStore } from './state';
import { useSystemStore } from '@/stores/system';

interface Props {
  variant?: 'primary' | 'compact' | 'fab';
  className?: string;
}

/**
 * 强平触发按钮 — §8.4.6 要求出现在三处:
 * - primary :仪表板第一屏右上角(警示红 + 比常规按钮大 30%)
 * - compact :资金账户大屏 / TopBar 紧凑变体
 * - fab     :移动端右下浮动(AppLayout 挂载)
 *
 * tradeLocked / liquidating 期间禁用,避免重复触发。
 */
export function ForceLiquidateButton({ variant = 'primary', className }: Props) {
  const open = useForceLiquidateStore((s) => s.open);
  const tradeLocked = useSystemStore((s) => s.tradeLocked);
  const liquidating = useSystemStore((s) => s.liquidation.active);
  const disabled = tradeLocked || liquidating;

  if (variant === 'fab') {
    return (
      <button
        type="button"
        onClick={open}
        disabled={disabled}
        aria-label="一键强制平仓"
        className={cn(
          'lg:hidden fixed bottom-5 right-5 z-40 h-14 w-14 rounded-full bg-down text-white shadow-2xl flex items-center justify-center btn-press',
          !disabled && 'animate-danger-pulse',
          disabled && 'opacity-50 cursor-not-allowed',
          className,
        )}
      >
        <Flame className="h-6 w-6" />
      </button>
    );
  }

  if (variant === 'compact') {
    return (
      <Button
        variant="destructive"
        size="sm"
        onClick={open}
        disabled={disabled}
        className={cn(!disabled && 'animate-danger-pulse', className)}
      >
        <Flame className="h-4 w-4" />
        <span className="hidden sm:inline">一键强制平仓</span>
      </Button>
    );
  }

  return (
    <Button
      variant="destructive"
      size="xl"
      onClick={open}
      disabled={disabled}
      className={cn('text-base font-bold uppercase tracking-wider', !disabled && 'animate-danger-pulse', className)}
    >
      <Flame className="h-5 w-5" />
      🔴 一键强制平仓
    </Button>
  );
}
